import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { useApi } from "../composables/useApi";
import { Notify } from "quasar";

const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;

export const fcmService = {
  /**
   * طلب الإذن وجلب التوكن مع دعم التجديد الإجباري
   */
  async initializeNotifications() {
    try {
      const supported = await isSupported();
      if (!supported) return null;

      // 🔥 تسجيل الـ SW يدوياً والتأكد من تفعيله لضمان عدم حدوث سباق (Race Condition)
      let registration;
      if ('serviceWorker' in navigator) {
        registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' });
        
        // الانتظار حتى يصبح الـ SW نشطاً (Active)
        await navigator.serviceWorker.ready;
        console.log("[FCM] Service Worker is ready and active.");
      } else {
        console.warn("[FCM] Service Workers are not supported in this browser.");
        return null;
      }

      const messaging = getMessaging();
      
      // ... (rest of checks) ...
      if (Notification.permission === 'denied') {
        console.warn("[FCM] Notifications are blocked by user.");
        return null;
      }

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return null;

      // جلب التوكن مع تمرير الـ registration بشكل صريح
      const token = await getToken(messaging, { 
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration
      });
      
      if (token) {
        const storedToken = localStorage.getItem('raqmoon_fcm_token');
        
        // لا نرسل للخلفية إلا إذا كان التوكن جديداً لتوفير الموارد
        if (token !== storedToken) {
          console.log("[FCM] New token generated:", token);
          await this.saveTokenToBackend(token);
          await this.subscribeToTopic(token, "system-updates");
          
          localStorage.setItem('raqmoon_fcm_token', token);
          localStorage.setItem('raqmoon_fcm_vapid', VAPID_KEY);
        }
        return token;
      }
    } catch (error) {
      console.error("[FCM] Init error:", error);
      // إذا فشل بسبب المفتاح، نمسح الكاش للمحاولة القادمة
      localStorage.removeItem('raqmoon_fcm_token');
      return null;
    }
  },

  /**
   * إرسال التوكن للخلفية لحفظه في DynamoDB
   */
  async saveTokenToBackend(fcmToken) {
    const { post } = useApi();
    try {
      await post('/profile/fcm-token', { fcmToken });
      console.log("[FCM] Token saved to backend successfully.");
    } catch (error) {
      console.error("[FCM] Failed to save token to backend:", error);
    }
  },

  /**
   * طلب الاشتراك في موضوع (Topic) لإشعارات جماعية
   */
  async subscribeToTopic(token, topic) {
    const { post } = useApi();
    try {
      await post('/profile/fcm-topic-subscribe', { token, topic });
      console.log(`[FCM] Subscribed to topic: ${topic}`);
    } catch (error) {
      console.error(`[FCM] Failed to subscribe to topic ${topic}:`, error);
    }
  },

  /**
   * الاستماع للرسائل أثناء فتح التطبيق (Foreground)
   */
  async listenForMessages() {
    const supported = await isSupported();
    if (!supported) return;

    try {
      const messaging = getMessaging();
      onMessage(messaging, (payload) => {
        console.log("[FCM] Message received in foreground:", payload);
        
        const title = payload.notification?.title || payload.data?.title || 'تنبيه جديد';
        const body = payload.notification?.body || payload.data?.body || '';

        Notify.create({
          message: title,
          caption: body,
          icon: 'notifications_active',
          position: 'top',
          timeout: 15000,
          // استخدام الكلاس العالمي لضمان الزجاجية
          classes: 'glass-notify',
          // إزالة الأزرار الافتراضية وإضافة زر واحد أنيق
          ignoreDefaults: true, 
          actions: [
            { icon: 'close', color: 'white', round: true, flat: true, dense: true }
          ]
        });
      });
    } catch (err) {
      console.error("[FCM] Failed to set up message listener:", err);
    }
  }
};
